// Zugriffsregel eines Standorts. Rein, ohne React und ohne helpers/index.js (das zieht
// aws-amplify und bricht Jest).
//
// Die Regel lebt hier, damit der PaymentContext (aktiver Standort) und der Standortwechsel
// (andere Standorte, Daten aus partnerControl getMySpacesPayments) dieselbe Entscheidung
// treffen. Nicht in payment-selection.js, diese Datei spiegelt Aivy OS byte-gleich.
import { selectPayments } from './payment-selection'

// Laufzeit-Check wie bisher in payment-context.js. Date.parse auf fehlende oder kaputte Werte
// ergibt NaN, damit ist die Laufzeit nicht aktiv. Bewusst kein new Date, denn new Date(null) ist
// 1970 und ließe einen Trial mit start_at null und künftigem expires_at durchgehen.
export const isPeriodActive = (payment, now = Date.now()) =>
  Date.parse(payment?.start_at) < now && now < Date.parse(payment?.expires_at)

// Hart abgelaufen ist ein Standort ohne Laufzeit-Payment oder mit einem Trial außerhalb seiner
// Laufzeit. Ein abgelaufenes Kunden-Payment sperrt bewusst nie. Zahlungen laufen regelmäßig aus,
// bevor die Verlängerung im Aivy OS hinterlegt ist, der Slack-Alert ist dort die Eskalation.
export const isAccessExpired = (periodPayment, now = Date.now()) =>
  !periodPayment ||
  (!isPeriodActive(periodPayment, now) && !!periodPayment.is_trial)

export const SPACE_ACCESS = Object.freeze({
  ACTIVE: 'ACTIVE',
  TRIAL: 'TRIAL',
  EXPIRED: 'EXPIRED'
})

// Zugang eines Standorts aus seinen Payments. Wie im PaymentContext entscheidet das neueste
// Nicht-Credit-Payment, ein abgelaufenes Kunden-Payment gilt als ACTIVE. Unlesbare Daten ergeben
// EXPIRED, denn ein unbekannter Standort darf nie als nutzbar gelten.
export const spaceAccessOf = (payments, now = Date.now()) => {
  try {
    const { periodPayment } = selectPayments(payments)

    if (isAccessExpired(periodPayment, now)) return SPACE_ACCESS.EXPIRED

    return periodPayment.is_trial ? SPACE_ACCESS.TRIAL : SPACE_ACCESS.ACTIVE
  } catch {
    return SPACE_ACCESS.EXPIRED
  }
}

export const hasSpaceAccess = (payments, now = Date.now()) =>
  spaceAccessOf(payments, now) !== SPACE_ACCESS.EXPIRED
